import {
	Card,
	Grid,
	type IconJVSProps,
	Segment,
	type SemanticWIDTHS,
} from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import './Panel.css';

interface PanelProps {
	children: React.ReactNode;
	code: string;
	icon: IconJVSProps;
	isMandatory: boolean;
	onRemove: () => void;
	size: SemanticWIDTHS;
}

const Panel = ({
	children = null,
	code = null,
	icon = null,
	isMandatory = false,
	onRemove = null,
	size = null,
}: PanelProps) => (
	<Grid.Column width={size} className="panelColumn">
		<Card fluid as={Segment}>
			<Card.Content className="flex panelCardContent">
				{icon && (
					<div className="panelIconContainer">
						<Icon {...icon} size={36} />
					</div>
				)}

				<Grid className="panelDataContainer">
					<Grid.Row stretched>
						<Grid.Column width={16}>{children}</Grid.Column>
					</Grid.Row>
				</Grid>

				{!isMandatory && (
					<Icon
						className="removeIcon"
						data-testid={`removeIndicateur${code}`}
						iconSet="Lucide"
						name="X"
						onClick={onRemove}
					/>
				)}
			</Card.Content>
		</Card>
	</Grid.Column>
);

export default Panel;
